// extracted by mini-css-extract-plugin
export default {"weekSelector":"Weekselector_weekSelector__0Ts3k","dayListItem":"Weekselector_dayListItem__C7vLJ"};